import React, { useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import StorageIcon from "@mui/icons-material/Storage";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LogoutIcon from "@mui/icons-material/Logout";
import ShowChartIcon from "@mui/icons-material/ShowChart";

const pages = ["Dashboard", "Backtest", "Paper Trading", "Live Signals", "Data Sync", "Heatmap"];

const getRoute = (page) => {
  const routes = {
    "Dashboard": "/",
    "Backtest": "/backtest",
    "Paper Trading": "/paper-trading",
    "Live Signals": "/signals",
    "Data Sync": "/data-sync",
    "Heatmap": "/heatmap",
    "Single Chart": "/chart",
    "Pair Chart": "/pair",
    "Sector Charts": "/sector",
    "Portfolio": "/portfolio",
    "Table": "/table",
    "Screener": "/screener",
    "Signals": "/signal",
  };
  return routes[page] || "/";
};

import { useNavigate } from "react-router-dom";

const NavigationBar = ({ onLogout }) => {
  const [time, setTime] = React.useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = React.useState(true);

  const navigate = useNavigate();
  return (
    <div>
      <AppBar position="sticky" color="inherit" elevation={1}>
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            style={{ marginRight: "10px" }}
          >
            StarkAI Trading
          </Typography>
          <Box sx={{ display: { xs: "none", md: "flex" }, flexGrow: 1 }}>
            {pages.map((page) => {
              const icon =
                page === "Data Sync" ? (
                  <StorageIcon sx={{ fontSize: 18 }} />
                ) : page === "Paper Trading" ? (
                  <ShowChartIcon sx={{ fontSize: 18 }} />
                ) : page === "Live Signals" ? (
                  <NotificationsActiveIcon sx={{ fontSize: 18 }} />
                ) : null;
              return (
                <Button
                  key={page}
                  onClick={() => {
                    navigate({
                      pathname: getRoute(page),
                    });
                  }}
                  sx={{ my: 1, color: "text.primary", display: "block", textTransform: "none", fontWeight: 500, fontSize: "0.875rem" }}
                  {...(icon && { startIcon: icon })}
                >
                  {page}
                </Button>
              );
            })}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" color="inherit">
              {localStorage.getItem("auth_user") || "User"}
            </Typography>
            <IconButton color="inherit" onClick={onLogout} title="Logout" size="small">
              <LogoutIcon />
            </IconButton>
          </Box>
          {/* <FormControl sx={{ width: "150px" }} size="small">
            <InputLabel id="demo-simple-select-label">Time</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={time}
              label="Time"
              onChange={handleChange}
            >
              <MenuItem value={"1"}>1 Day</MenuItem>
              <MenuItem value={"3"}>3 Day</MenuItem>
              <MenuItem value={"30"}>1 Month</MenuItem>
              <MenuItem value={"90"}>3 Months</MenuItem>
            </Select>
          </FormControl> */}
        </Toolbar>
      </AppBar>
      {/* <div
        style={{
          width: "100%",
          marginTop: "5px",
          display: "flex",
          flexDirection: "row-reverse",
        }}
      >
        <ButtonGroup
          size="small"
          variant="outlined"
          aria-label="outlined primary button group"
          style={{ marginRight: "10px" }}
        >
          <Button
            variant={time == "1" ? "contained" : "outlined"}
            onClick={() => {
              setTime("1");
            }}
          >
            1 Day
          </Button>
          <Button
            variant={time == "3" ? "contained" : "outlined"}
            onClick={() => {
              setTime("3");
            }}
          >
            3 Days
          </Button>
          <Button
            variant={time == "30" ? "contained" : "outlined"}
            onClick={() => {
              setTime("30");
            }}
          >
            1 Month
          </Button>
          <Button
          variant={time == "90" ? "contained" : "outlined"}
            onClick={() => {
              setTime("90");
            }}
          >
            3 Months
          </Button>
          <Button
          variant={time == "180" ? "contained" : "outlined"}
            onClick={() => {
              setTime("180");
            }}
          >
            6 Months
          </Button>
          <Button
          variant={time == "365" ? "contained" : "outlined"}
            onClick={() => {
              setTime("365");
            }}
          >
            1 Year
          </Button>
          <Button
          variant={time == "730" ? "contained" : "outlined"}
            onClick={() => {
              setTime("730");
            }}
          >
            2 Years
          </Button>
          <Button
          variant={time == "1825" ? "contained" : "outlined"}
            onClick={() => {
              setTime("1825");
            }}
          >
            5 Years
          </Button>
          <Button
          variant={time == "3650" ? "contained" : "outlined"}
            onClick={() => {
              setTime("3650");
            }}
          >
            10 Years
          </Button>
          <Button
          variant={time == "max" ? "contained" : "outlined"}
            onClick={() => {
              setTime("max");
            }}
          >
            Max
          </Button>
        </ButtonGroup>
      </div> */}
    </div>
  );
};

export default NavigationBar;
